// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  needCaptcha: true,
  // 104开发环境
  // projectId: 1004,
  // title: '公路建管平台',
  // host: 'https://104test.hzsksc.com:9092',
  // fileHost: 'https://104test.hzsksc.com:19102',

  // host: 'https://104beta.hzsksc.com:8082',
  // fileHost: 'https://104beta.hzsksc.com:19102',

  // host: 'http://104.hzsksc.com:19003',
  // fileHost: 'http://104.hzsksc.com:19008',

  // 三桥开发环境
  projectId: 1005,
  title: '大桥建管平台',
  host: 'https://104test.hzsksc.com:10501',
  fileHost: 'https://104test.hzsksc.com:19103',

  // 三桥正式环境
  // host: 'https://sanqiao.hzsksc.com:29000',
  // fileHost: 'https://sanqiao.hzsksc.com:19002',

  version: '2026-11-05 17:30:14',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
